import gql from 'graphql-tag';

export const unsubscribeApacSavedSearchByCode = gql`
  mutation UnsubscribeApacSavedSearchByCode(
    $input: UnsubscribeApacSavedSearchByCodeInput!
  ) {
    unsubscribeApacSavedSearchByCode(input: $input) {
      ... on UnsubscribeApacSavedSearchByCodeFailure {
        error {
          message
        }
      }
    }
  }
`;

export const resubscribeApacSavedSearchByCode = gql`
  mutation ResubscribeApacSavedSearchByCode(
    $input: ResubscribeApacSavedSearchByCodeInput!
  ) {
    resubscribeApacSavedSearchByCode(input: $input) {
      ... on ResubscribeApacSavedSearchByCodeFailure {
        error {
          message
        }
      }
    }
  }
`;
